import React from 'react';
import { Box } from '@chakra-ui/react';

export const SectionTitle = ({ children, ...rest }) => (
  <Box fontSize={'2xl'} fontWeight="bold" mb={4} {...rest}>
    {children}
  </Box>
);
